import { useMemo } from 'react';

import {
  PreparedWorkload,
  useOptimizationWorkloads,
} from 'features/workload-optimization';

import { Filters } from './_components/Filters';
import { isWorkloadOptimized } from '../../_utils';
import { WorkloadsTable } from './_components/WorkloadsTable/WorkloadsTable';
import { useImpactWorkloadsCriteria } from './_hooks/useImpactWorkloadsCriteria';

import { SearchProvider } from '@cast/shared-search-ui';
import { tableCacheKeys } from 'constants/tableCacheKeys';

type WorkloadsSectionProps = {
  urlKey?: string;
  cacheKey?: string;
  getWorkloadLink?: (workload: PreparedWorkload) => string | undefined;
  includeWorkloadTypeInSearchBox?: boolean;
};

export const WorkloadsSection = ({
  urlKey = 'woop-impact-list',
  cacheKey = tableCacheKeys.WORKLOAD_OPTIMIZATION.IMPACT_WORKLOADS_LIST,
  getWorkloadLink,
  includeWorkloadTypeInSearchBox,
}: WorkloadsSectionProps = {}) => {
  const { workloads, isLoading } = useOptimizationWorkloads();
  const criteria = useImpactWorkloadsCriteria({
    includeWorkloadTypeInSearchBox,
  });
  const onlyOptimizedWorkloads = useMemo(
    () => workloads.filter(isWorkloadOptimized),
    [workloads]
  );

  return (
    <SearchProvider<PreparedWorkload>
      criteria={criteria}
      data={onlyOptimizedWorkloads}
      isLoading={isLoading}
      urlKey={urlKey}
    >
      <Filters />

      <WorkloadsTable cacheKey={cacheKey} getWorkloadLink={getWorkloadLink} />
    </SearchProvider>
  );
};
